import type { CustomDirectusTypes } from '@/models/types';
import {
  type CollectionType,
  type DirectusFile,
  type Query,
  authentication,
  createDirectus,
  rest,
} from '@directus/sdk';

export type RequestQuery<T> = Query<CustomDirectusTypes, T>;
export type MutationQuery<T> = Query<CustomDirectusTypes, T[]>;

export type RequestQueryFile = Query<CustomDirectusTypes, DirectusFile<CustomDirectusTypes>>;

export type TQuery<T extends keyof CustomDirectusTypes> = Query<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, T>
>;

export type DirectusErrorType = {
  errors: [
    {
      message: string;
      extensions: {
        code: string;
      };
    },
  ];
};

// Nom du provider configuré dans Directus (AUTH_PROVIDERS)
export const DIRECTUS_SSO_PROVIDER = 'keycloak';

const directus = createDirectus<CustomDirectusTypes>(import.meta.env.VITE_DIRECTUS_URL)
  .with(authentication('session', { credentials: 'include' }))
  .with(rest({ credentials: 'include' }));

export default directus;

/**
 * Tente de rafraîchir la session Directus via le cookie de session.
 * Retourne true si la session est active, false sinon.
 */
export const initDirectusSession = async (): Promise<boolean> => {
  try {
    await directus.refresh();
    return true;
  } catch {
    return false;
  }
};

/**
 * Ferme la session Directus courante (cookie de session).
 * Les erreurs sont ignorées côté appelant pour ne pas bloquer la déconnexion OIDC.
 */
export const logoutDirectusSession = async (): Promise<void> => {
  try {
    await directus.logout();
  } catch {
    // no-op
  }
};
